import { Component, ViewContainerRef } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { LoadingController } from 'ionic-angular';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';
import { UtilsProvider } from '../../providers/utils/utils'
import { TiposReservasProvider } from '../../providers/tiposReservas/tiposReservas';

@IonicPage()
@Component({
  selector: 'page-tipos-reservas',
  templateUrl: 'tipos-reservas.html',
  providers: [ AuthService,ElectronService, TiposReservasProvider ]
})
export class TiposReservasPage {

  tiposReservas = []
  nombreTiposReserva
  color
  descripcion
  controlaprecio
  tiposReservasId
  loader
  editarProducto
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null
  modo:boolean = MODO_DESCONECTADO === undefined ? true : MODO_DESCONECTADO
  uuId
  nombreTiposReservaAyuda="El primer registro ingresado que el campo 'Controla precio' este en 'No' será el registro por defecto a la hora de hacer una reserva";
  public toggle: boolean = false;

  public colorList = [
    { key: "red", value: "#ff0000", friendlyName: "Red" },
    { key: "blue", value: "#0000ff", friendlyName: "Blue" },
    { key: "#083472", value: "#083472", friendlyName: "#083472" },
    { key: "#FD0404", value: "#FD0404", friendlyName: "#FD0404" },
    { key: "#D6C906", value: "#D6C906", friendlyName: "#D6C906" },
    { key: "#08726A", value: "#08726A", friendlyName: "#08726A" },
    { key: "#006400", value: "#006400", friendlyName: "#006400" },
    { key: "#90A3D3", value: "#90A3D3", friendlyName: "#90A3D3" },
    { key: "flame", value: "#e45a33", friendlyName: "Flame" },
    { key: "orange", value: "#fa761e", friendlyName: "Orange" },
    { key: "infrared", value: "#ef486e", friendlyName: "Infrared" },
    { key: "male", value: "#4488ff", friendlyName: "Male Color" },
    { key: "female", value: "#ff44aa", friendlyName: "Female Color" },
    { key: "paleyellow", value: "#ffd165", friendlyName: "Pale Yellow" },
    { key: "gargoylegas", value: "#fde84e", friendlyName: "Gargoyle Gas" },
    { key: "androidgreen", value: "#9ac53e", friendlyName: "Android Green" },
    { key: "carribeangreen", value: "#05d59e", friendlyName: "Carribean Green" },
    { key: "bluejeans", value: "#5bbfea", friendlyName: "Blue Jeans" },
    { key: "cyancornflower", value: "#1089b1", friendlyName: "Cyan Cornflower" },
    { key: "warmblack", value: "#06394a", friendlyName: "Warm Black" }
  ];

public selectedColor: string = ''; // Variable para almacenar el color seleccionado

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: TiposReservasProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public mensaje: UtilsProvider,
    private _electronService: ElectronService
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          let tmodo = MODO_DESCONECTADO

          if(tmodo){
            let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-tiposReservas',RUTA_MODO_DESCONECTADO)
            if(resultado){
              this.tiposReservas = []
              this.tiposReservas = JSON.parse(resultado)
            }

          }else{
            this.cargarReservas()
          }
        }
      })

  }

  mostrarColores: boolean = false;

mostrarPaletaColores() {
    this.mostrarColores = !this.mostrarColores;
}

seleccionarColor(color: string) {
    this.selectedColor = color;
    this.mostrarColores = false;
    this.color = color;
}

  cargarReservas() {
    this.tiposReservas = []

    this.servicio.buscarTiposReservasCompaniasId(this.companiasId)
    .subscribe(
      (res: any) => {
        if(NUBE_AWS) {
          this.tiposReservas =  JSON.parse(res['_body']).data[0]
        } else {
          this.tiposReservas = res
        }
        },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar tipos reserva, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
  }

  guardar() {

    this.loader = this.loadingCtrl.create({});
    this.loader.present();

    let datosProducto: any = {
      nombreTiposReserva: this.nombreTiposReserva,
      tiposReservasId: this.tiposReservasId == undefined ? "0" : this.tiposReservasId,
      color: this.color,
      descripcion: this.descripcion,
      controlaprecio: this.controlaprecio,
      uuId:this.uuId
    }

    this.storage.get('companiasId').then((val) => {
      datosProducto['companiasId'] = val
      if(MODO_DESCONECTADO){
        let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosProducto,'c:\\bd','tiposReservas')
           let valoresnuevos = resultado
           this.limpiar()
           this.loader.dismiss()

            let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-tiposReservas',RUTA_MODO_DESCONECTADO)
            if(resultadoNuevo){
              this.tiposReservas = []
              this.tiposReservas = JSON.parse(resultadoNuevo)
           }

      }else{
      if(this.editarProducto){
        this.editarProducto = false;
        this.editarProduct(datosProducto)
      } else {
        this.guardarProducto(datosProducto)
      }
    }
    });
  }

  editarProduct(datosProducto) {
    datosProducto['tiposReservasId'] = this.tiposReservasId

          let datos: any = {
            companiasId: datosProducto.companiasId,
            queHago: "A",
            nombreTabla: "tiposReservas",
            name: "dataDynamicCrud",
            tiposReservasId: datosProducto.tiposReservasId,
            nombreTiposReserva:datosProducto.nombreTiposReserva,
            color: datosProducto.color,
            descripcion: datosProducto.descripcion,
            controlaprecio: datosProducto.controlaprecio,
            prioridad: 0
          }
          this.servicio.actualizar(datos).subscribe((data)=> {
            this.mensaje.mensajeMuestro('Tipos reserva','tipo reserva actualizado con Éxito!','success')
            this.procesarResultado()
          }, (err) => {
            this.mensaje.mensajeMuestro('Tipos reserva','No se pudo actualizar el tipo reserva, intente luego','error')
            this.procesarResultado()
          })

    }

 guardarProducto(datosProducto){
   let datos: any = {
          companiasId: datosProducto.companiasId,
          queHago: "I",
          nombreTabla: "tiposReservas",
          name: "dataDynamicCrud",
          tiposReservasId: datosProducto.tiposReservasId,
          nombreTiposReserva:datosProducto.nombreTiposReserva,
          color: datosProducto.color,
          descripcion: datosProducto.descripcion,
          controlaprecio: datosProducto.controlaprecio,
          prioridad: 0
        }
        this.servicio.guardar(datos).subscribe((data: any)=> {
          this.mensaje.mensajeMuestro('Tipo reservas','Tipo reservas  almacenado con Éxito!','success')
          this.procesarResultado()
        },(error) => {
        console.log('error', error)
        this.mensaje.mensajeMuestro('Tipo resrvas','No se pudo guardar el Tipo reserva, intente luego',error)
        this.procesarResultado()
      })
  }

  limpiar() {
    this.nombreTiposReserva = ""
    this.tiposReservasId = 0
    this.color = ""
    this.descripcion = ""
    this.controlaprecio = "0"
    this.uuId = undefined
  }

  editar(item){
    this.nombreTiposReserva = item.nombreTiposReserva
    this.tiposReservasId = item.tiposReservasId
    this.color = item.color
    this.descripcion = item.descripcion
    this.controlaprecio = item.controlaprecio
    this.editarProducto = true
    this.uuId = item.uuid
  }

  eliminar(item) {
    this.mensaje.mensajeConfirmacionDos('Tipo reservas','¿Está seguro de eliminar el registro?','question','Si','No')
    .then((laRespuesta: boolean) =>{
      if (laRespuesta){
        this.loader = this.loadingCtrl.create({});
        this.loader.present();
        if(MODO_DESCONECTADO === undefined){
          this.modo = true
        }else{
          this.modo = MODO_DESCONECTADO
        }
        if(this.modo){
          let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-tiposReservas-eliminar',item)
          if(resultadoNuevo){

            this.limpiar()
            this.loader.dismiss()
            this.tiposReservas = []

            let valores = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-tiposReservas')
            if(valores){
              this.tiposReservas = JSON.parse(valores)
            }
          }
        }else{
          this.servicio.eliminar(item)
          .subscribe(
          res => {
            this.mensaje.mensajeMuestro('Tipos reserva','Registro eliminado con Éxito!','success')
            this.procesarResultado()
          },
          err => {
            this.procesarResultado()
            this.mensaje.mensajeMuestro('Tipos reserva','No se pudo eliminar el Tipos reserva, intente luego','error')
          }
          )
        }
      }
      else {
        this.limpiar()
        this.cargarReservas()
        this.mensaje.mensajeMuestro('Tipos reserva','No se eliminó el registro','warning')
      }
    })
  }

  procesarResultado() {
    this.limpiar()
    this.loader.dismiss()
    this.cargarReservas()
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();

    this.loader.dismiss()
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/tipos-reservas/tipos-reservas.ts